import React from 'react';
import { ReactComponent as DrawerIcon } from 'src/assets/icons/fi-rr-indent.svg';
import Avatar from '../Avatar';
import { filterProfilesByName } from 'src/utils/getProflleValuesByArray';
// import { getCookie } from 'src/utils/cookies';
// import { jwtDecode } from 'src/utils/jwtDecode';
import { ReactComponent as LinkedInSvg } from 'src/assets/icons/social-icon-linkedin.svg';
import DrawerV2 from '../DrawerV2';

type Profile = {
  name: string;
  src: string;
  designation: string;
};
type DrawerProps = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  row: any;
  profilesData: Profile[];
  selectedIndex: number;
  data: any;
};

const ConnectionPathDrawer = React.memo(function CustomDrawerFunction({
  open,
  setOpen,
  row,
  profilesData,
  selectedIndex,
  data,
}: DrawerProps) {
  const onClose = () => {
    setOpen(false);
  };
  const connectionPathData = data[selectedIndex]?.connectionPath;
  const filterProfilesData = filterProfilesByName(connectionPathData);
  // const token = getCookie('user');
  // const decodedToken = jwtDecode(token);
  // const fullName = `${decodedToken.firstName} ${decodedToken.lastName}`;
  return (
    <div>
      {open && (
        <div className="drawer-close-btn">
          <span>
            <DrawerIcon onClick={onClose} />
          </span>
        </div>
      )}
      <DrawerV2
        enforceFocus
        autoFocus
        backdrop
        show={open}
        onHide={onClose}
        size="lg"
        placement="right"
      >
        <div className="drawer">
          <div className="drawer-header">
            Connections to {data[selectedIndex]?.FirstName} {data[selectedIndex]?.LastName} (
            {filterProfilesData.length})
          </div>
          <div className="drawer-body">
            {filterProfilesData.map((item: Profile, index) => (
              <div className="card-layout" key={`${item.name}${index}`}>
                <div className="card-name-image">
                  <Avatar src={item.src} name={item.name} height={50} width={50} />

                  <div className="name-designation">
                    <div className="card-name">{item.name}</div>
                    <div className="card-designation">{item.designation}</div>
                  </div>
                  <div className="linkedin-icon">
                    <LinkedInSvg className="icon-enabled" height={15} width={15} />
                    <div className="connected-linkedin">Connected on Linkedin</div>
                  </div>
                </div>
                {/* {item.name !== fullName && <div className="introduction">Ask for Introduction</div>} */}
              </div>
            ))}
          </div>
        </div>
      </DrawerV2>
    </div>
  );
});

export default ConnectionPathDrawer;
